import { Component, OnInit } from '@angular/core';
import { Cliente } from '../../core/model/cliente';
import { ComboCliente } from '../../core/model/combos';
import { Contenedores, Expedientes, InventoryIdenty, IResultadoDocument, TIPO_DOCUMENTAL, TypeShoppingCart } from '../../core/model/inventories';
import { AzDetail } from '../../core/model/inventory-detail/az-detail';
import { Page } from '../../core/model/page';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ClientesService } from '../../core/services/clientes.service';
import { SessionService } from '../../core/services/session.service';
import { ShoppingElementsService } from '../../core/services/shopping-elements.service';

@Component({
  selector: 'app-carrito',
  templateUrl: './carrito.component.html',
  styleUrls: ['./carrito.component.css']
})
export class CarritoComponent implements OnInit {

  title: string;
  description: string;
  rootBreadcumb: string;
  childBreadcumb: string;
  isDocoutUser: boolean;

  clients: Cliente[] = [];

  loading = true;
  expedientesByClient: {
    client: ComboCliente;
    expedientesByType: { page: Page; expedientes: IResultadoDocument<Expedientes>[] }[];
  }[] = [];

  constructor(
    private authService: AuthenticationService,
    private shoppingElementsService: ShoppingElementsService,
    private clientsService: ClientesService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.authService.getClienteName$().subscribe(rootBreadcumb => {
      this.rootBreadcumb = rootBreadcumb;
    });

    this.shoppingElementsService.allElements$
      .subscribe((expedientes: IResultadoDocument<Expedientes>[]) => {
        if (expedientes && expedientes.length > 0) {
          this.initValues(expedientes);
        } else {
          this.expedientesByClient = [];
          this.loading = false;
        }
      });
  }

  private initValues(expedientes: IResultadoDocument<Expedientes>[]) {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.initializeShoppingCart(isDocUser, expedientes);
      });
  }

  private initializeShoppingCart(isDocoutUser: boolean, expedientes: IResultadoDocument<Expedientes>[]) {
    this.isDocoutUser = isDocoutUser;
    if (this.isDocoutUser && this.clients.length > 0) {
      this.setExpedientes(expedientes);
    } else if (this.isDocoutUser) {
      this.clientsService.getAllClientes()
        .subscribe((clients: Cliente[]) => {
          this.clients = clients;
          this.setExpedientes(expedientes);
        });
    } else {
      const comboCliente = new ComboCliente();
      comboCliente.Id = this.sessionService.getClientId();
      comboCliente.NOMBRE = this.authService.getClienteName();
      this.expedientesByClient = [];
      this.expedientesByClient.push({
        client: comboCliente,
        expedientesByType: this.getExpedientesByType(expedientes)
      });
      this.loading = false;
    }
  }

  private setExpedientes(expedientes: IResultadoDocument<Expedientes>[]) {
    this.expedientesByClient = this.getRecordsGroupsByClient(expedientes);
    this.loading = false;
  }

  private getRecordsGroupsByClient(datas: InventoryIdenty[]) {

    const group_to_values = datas.reduce(function (obj, item) {
      const clienteId = (item.tipoDocumental === TIPO_DOCUMENTAL.expediente) ? (<IResultadoDocument<Expedientes>>item).document.clienteId
        : (item.tipoDocumental === TIPO_DOCUMENTAL.contenedor ? (<Contenedores>item).clienteId : (<AzDetail>item).clienteId);
      obj[clienteId] = obj[clienteId] || [];
      obj[clienteId].push(item);
      return obj;
    }, {});

    const groups = Object.keys(group_to_values).map(key => {
      const keyNumber = parseInt(key, 10);
      const clientRecord = this.clients.find(client => client.ID == keyNumber);

      if (clientRecord) {
        const comboCliente = new ComboCliente();
        comboCliente.Id = keyNumber;
        comboCliente.NOMBRE = clientRecord.NOMBRE;
        return {
          client: comboCliente,
          expedientesByType: this.getExpedientesByType(group_to_values[key] as IResultadoDocument<Expedientes>[])
        };
      }
    });

    return groups.filter(group => group !== undefined);
  }

  private getExpedientesByType(expedientes: IResultadoDocument<Expedientes>[]) {
    const validTypes: TypeShoppingCart[] = [TypeShoppingCart.LOAN, TypeShoppingCart.INSERTION];
    const groupsByType_to_values = expedientes.reduce(function (obj, item) {
      const type: TypeShoppingCart = validTypes.indexOf(item.shoppingCart.type) == -1
        ? TypeShoppingCart.LOAN : item.shoppingCart.type;
      obj[type] = obj[type] || [];
      obj[type].push(item);
      return obj;
    }, {});

    const groupsByType = Object.keys(groupsByType_to_values).map(key => {
      return {
        page: this.getNewPage(),
        expedientes: groupsByType_to_values[key] as IResultadoDocument<Expedientes>[]
      };
    });

    return groupsByType;
  }

  private getNewPage(): Page {
    const page = new Page();
    page.pageNumber = 0;
    page.size = 10;
    return page;
  }

}
